import { render, staticRenderFns } from "./AnnouncementsListView.vue?vue&type=template&id=6c6f28fc"
import script from "./AnnouncementsListView.vue?vue&type=script&lang=js"
export * from "./AnnouncementsListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports